<template>
    <el-container class="userinfo">
      <div id="userbox">
         <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="5" class="user" style="padding-left: 10px; padding-right: 10px;">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <p style="margin:0;">Personal Information</p>
            </div>
            <div>
              <div style="text-align: center">
                <el-upload
                  :show-file-list="false"
                  :on-success="handleSuccess"
                  :on-error="handleError"
                  :headers="headers"
                  :action="updateAvatarApi"
                  class="avatar-uploader">
                  <img v-if="avatar" :src="avatar" title="Upload Avatar" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"/>
                  <p class="changeH">Change</p>
                </el-upload>
              </div>
              <ul class="user-info">
                <li><svg-icon icon-class="user1" /> User name <div class="user-right">{{ user.username }}</div></li>
                <li><svg-icon icon-class="email" /> User mailbox <div class="user-right">{{ user.email }}</div></li>
                <li><svg-icon icon-class="date" /> Date created <div class="user-right">{{ parseTime(user.createTime) }}</div></li>
                <li><svg-icon icon-class="timeout" /> Account expiration <div class="user-right">{{ parseTime(user.accountTerm) }}</div></li>
                <li><svg-icon icon-class="vip" /> Member expiration <div class="user-right" style="color:#d9bf0a">{{ parseTime(user.vipTerm) || "You haven't opened a member yet"}}</div></li>
                <li>
                  <svg-icon icon-class="anq" /> Security setting
                  <div class="user-right">
                    <a @click="$refs.pass.dialog = true">Change Password</a>
                  </div>
                </li>
              </ul>
            </div>
          </el-card>
          <div class="modify">
              <!-- <div class="item" :class="{'active':position === 1}" label="simple1" @click="toSim(1)">
                  <a href="#" class="Preference">我的实验
                      <svg-icon icon-class="myex" style="float:left;" />
                  </a>
              </div> -->
              <!-- <div class="item" :class="{'active':position === 2}" label="simple2" @click="toSim(2)">
                  <a href="#" class="Preference">我的收藏
                      <svg-icon icon-class="collection" style="float:left;" />
                  </a>
              </div> -->
              <!-- <div class="item" :class="{'active':position === 3}" label="simple3" @click="toSim(3)">
                  <a href="#" class="Preference">偏好设置
                      <svg-icon icon-class="hobby" style="float:left;" />
                  </a>
              </div> -->
              <div class="item" @click="routerTo">
                  <a href="#" class="Preference">Back to home
                      <svg-icon icon-class="home" style="float:left;" />
                  </a>
              </div>
          </div>
        </el-col>
        <!-- <el-col :xs="24" :sm="16" :md="16" :lg="18" :xl="19" style="padding-left: 10px; padding-right: 10px;" class="col2">
            <keep-alive>
              <component :is="tabView"></component>
            </keep-alive>
        </el-col> -->
      </div>
      <updatePassEn ref="pass"/>
      <!-- <div id="el-main-footer">
          <span>© 2020 Shanghai Judao Net-Tech Co., Ltd.</span>
          <span> ⋅ </span>
          <a href="http://www.beian.miit.gov.cn" target="_blank">Huicpb16019102</a>
          <span> ⋅ </span>
          <span>Business QQ:3235186608</span>
          <span> ⋅ </span>
          <span>Product QQ:3512883254</span>
      </div> -->
    </el-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { getToken } from '@/utils/auth'
import store from '@/store'
import updatePassEn from './center/updatePassEn'
import request from '@/utils/request'
import { parseTime } from '@/utils/index'
// import { resolve } from 'dns';
import simple1 from "../simple/simple1.vue";
import simple2 from "../simple/simple2.vue";
import simple3 from "../simple/simple3.vue";

export default {
    // 跳转首页刷新页面
    inject:['reload'],
    data(){
        return{
          position:3,
          tabView: "simple3",
            headers: {
                'Authorization': 'Bearer ' + getToken()
            },
            user:{},
        }
    },
    computed: {
        ...mapGetters([
          'avatar',
          'updateAvatarApi'
        ])
    },
    components: {
      simple1,
      simple2,
      simple3,
      updatePassEn
    },
    created() {
        this.getinfo();
        store.dispatch('GetInfo').then(() => {})
    },
    beforeRouteLeave(to, from, next) {
      if (to.path == "/en") {
        to.meta.keepAlive = true;
      } else {
        to.meta.keepAlive = false;
      }
        next();
    },
    methods: {
        parseTime,
        toSim(index){
          this.tabView = `simple${index}`;
          this.position = index
        },
        // 返回首页
        routerTo(){
          // window.open("http://www.judaoedu.com/");
          this.$router.push({path:'/en'})
          this.reload();
        },
        //获取到info
        getinfo(){
          request({
              method:'get',
              url:'auth/info'
          }).then(res=>{
              this.user = res.jwtUser
          })
        },
        // 头像
        handleSuccess(response, file, fileList) {
          this.$notify({
              message: 'Successfully',
              type: 'success',
              duration: 1500
          })
          store.dispatch('GetInfo').then(() => {})
        },
        // 监听上传失败
        handleError(e, file, fileList) {
          const msg = JSON.parse(e.message)
          this.$notify({
              message: msg.message,
              type: 'error',
              duration: 1500
          })
        },
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .user{
      position: absolute;
      left:50%;
      transform: translateX(-50%);
  }
    #el-main-footer{
        background:none repeat scroll 0 0 white;
        border-top:1px solid #e7eaec;
        overflow:hidden;
        padding:10px 6px 0px 6px;
        font-size:0.7rem !important;
        color:#7a8b9a;
        letter-spacing:0.8px;
        font-family:Arial, sans-serif !important;
        position: fixed;
        bottom: 0;
        height: 33px;
        z-index:2000;
        width: 100%;
    }
  ul>li,ol>li{
    list-style: none;
  }
  .el-container{width: 100%;height: 100%;position: relative;min-height: 100vh;}
 .userinfo{
     background-color: #f5f5f5;
 }
  #userbox{
      width: 1900px;
      margin: 83px auto;
      margin-bottom: 0;
}
.modify{
    // box-shadow:0 2px 12px 0 rgba(0,0,0,.1);
    padding: 20px;
    background-color: #fff;
    border: 1px solid #EBEEF5;
    border-top: none;
    .item{
      display: block;
      line-height: 42px;
      cursor: pointer;
      color: #888;
    }
    .item:hover{
      color:#ec6f28 ;
    }
    .svg-icon{
      margin-top: 12px;
      margin-left: 10px;
      margin-right:10px;
    }
    .active{
      border-radius: 2px;
      background-color: #fef7ed;
      color: #ec6f28 ;
    }
}
.box-card{
  box-shadow: none;
}
  .avatar-uploader /deep/ .el-upload{
      border-radius: 50%;
      box-shadow: 0px 19px 61px 0px rgba(28,28,28,0.1);
      position: relative;
      overflow: hidden;
  }
  .avatar-uploader /deep/ .changeH{
    width: 100%;
    height: 36px;
    line-height: 36px;
    background-color: rgba($color: #000000, $alpha: 0.3);
    position: absolute;
    color: #fff;
    font-size: 16px;
    font-weight: 400;
    bottom: 0;
    margin: 0;

  }
  .avatar-uploader-icon {
    font-size: 28px;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center
  }
  .clearfix>p>span{
    position: absolute;
    right: 2%;
    top: 2%;
    font-size: 22px;
    cursor: pointer;
  }
  .avatar {
    width: 120px;
    height: 120px;
    display: block;
    border-radius: 50%
  }
  .user-info {
    padding-left: 0px;
    list-style: none;
    li{
      border-bottom: 1px solid #F0F3F4;
      border-top: 1px solid #F0F3F4;
      padding: 11px 0px;
      font-size: 13px;
    }
    .user-right {
      float: right;
      a{
        color: #f1ad4e;
      }
    }
  }
  .el-header{
    background-color: #fff;
    text-align: center;
    position: relative;
    height: 60px;
    line-height: 60px;
    p{
      margin: 0;
      font-size: 20px;
    }
    .closeuser{
      position: absolute;
      top: 0;
      right: 0;
    }
  }
  .col2 /deep/ .el-card__body{
    padding: 0;
  }
  @media (max-width: 1024px){
    .modify{
      padding: 10px !important;
      padding-bottom: 30px !important;
    }
  }
  @media screen and (min-width:2049px) and (max-width:2560px){
      #el-main-footer{
          background:none repeat scroll 0 0 white;
          border-top:1px solid #e7eaec;
          overflow:hidden;
          padding:26px 6px 0px 6px;
          font-size:0.7rem !important;
          color:#7a8b9a;
          letter-spacing:0.8px;
          font-family:Arial, sans-serif !important;
          position: fixed;
          bottom: 0;
          height: 60px;
          z-index:1000;
          width: 100%;
      }
  }
</style>


// WEBPACK FOOTER //
// src/views/layout/components/PersonalEn.vue